import { motion } from "framer-motion";
import { MEDIA } from "../lib/media";

const GALLERY_ITEMS = [
  { src: MEDIA.foodPlatter, alt: "Plato variado de Suchimex", span: "col-span-2 row-span-2" },
  { src: MEDIA.nachos, alt: "Nachos Suchimex con ambiente mexicano", span: "col-span-1 row-span-1" },
  { src: MEDIA.cocktail1, alt: "Cóctel con Quesaliteca y nachos", span: "col-span-1 row-span-1" },
  { src: MEDIA.tacosPlatter, alt: "Tacos y aperitivos de la cocina", span: "col-span-1 row-span-1" },
  { src: MEDIA.coffePastry, alt: "Café gourmet Coffee Mex con pan dulce", span: "col-span-1 row-span-1" },
  { src: MEDIA.cocktail2, alt: "Cóctel festivo con calaveras decorativas", span: "col-span-1 row-span-1" },
  { src: MEDIA.drinksSpread, alt: "Jarra de cóctel azul con Quezalteca y calaveras", span: "col-span-2 row-span-1" },
  { src: MEDIA.hotDogMex, alt: "Platillo especial Suchimex", span: "col-span-1 row-span-1" },
];

export const RestaurantSection = () => {
  return (
    <section id="restaurante" data-testid="restaurant-section" className="py-24 md:py-32 bg-[#EBE3D5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="overline text-[#A25F4B] mb-4">Gastronomía</p>
          <h2
            data-testid="restaurant-title"
            className="font-heading text-4xl md:text-5xl tracking-tight text-[#2D2A26]"
          >
            Nuestra Cocina
          </h2>
          <p className="mt-6 text-[#5C5750] text-base md:text-lg max-w-2xl mx-auto leading-relaxed font-body">
            Sabores auténticos que fusionan la tradición mexicana con ingredientes frescos y locales.
            Desde nuestros nachos y platillos variados hasta cócteles creativos y café gourmet,
            cada momento en Suchimex es una celebración.
          </p>
        </motion.div>

        {/* Bento Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[200px] md:auto-rows-[250px]">
          {GALLERY_ITEMS.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className={`gallery-item ${item.span} relative`}
              data-testid={`restaurant-gallery-item-${i}`}
            >
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-all duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
